import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { enumEntries20mr21zbe3az4 as enumEntries } from '../../../../../../kotlin-kotlin-stdlib/kotlin/enums/EnumEntries.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  FreeText_getInstance23qqf2uelwn34 as FreeText_getInstance,
  FreeNumber2skpobtqdwens as FreeNumber,
  Scale39z6qxcb8qv as Scale,
  MultipleChoice1goezt0bzeu0r as MultipleChoice,
  SingleChoice36vk2iz8s7aee as SingleChoice,
  _ID___init__impl__k1lb7e161ss4vhqho8h as _ID___init__impl__k1lb7e,
  ID2laazuggebybv as ID,
  ShowCondition2dds7obgg0q2o as ShowCondition,
  Questionfghiyjhvplgs as Question,
  ID__toString_impl_y5caka3idz1jn8rtovq as ID__toString_impl_y5caka,
  ID__hashCode_impl_f4lulz2dcc8zh8xyyob as ID__hashCode_impl_f4lulz,
  _ID___init__impl__k1lb7e2eizzchxtswdr as _ID___init__impl__k1lb7e_0,
  QuestionResponse2c5i2ax2qx74j as QuestionResponse,
  Survey1bcnex3xrekf as Survey,
  Audience_AnonymousEmployee_getInstance2bv7u5yl59uph as Audience_AnonymousEmployee_getInstance,
  get_entries3lu97yqkn0182 as get_entries,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/survey.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString,
  toSet2orjxp16sotqu as toSet,
  plus20p0vtfmu0596 as plus,
  last1vo29oleiqj36 as last,
  plus310ted5e4i90h as plus_0,
  toList3jhuyej2anx2q as toList,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Companion_getInstance2o9uk4k3kfl5 as Companion_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import {
  lines3g90sq0zeq43v as lines,
  trim11nh7r46at6sx as trim,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  modify1cw751ztekmcu as modify,
  withWritedlio9p0oewet as withWrite,
} from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import {
  minus27abgkurcn6u0 as minus,
  plus18eogev54fmsa as plus_1,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { questionDisplay2vqssrhtzz6vu as questionDisplay } from './surveyComponents.mjs';
import { LocalDateRangefowoyqa24icz as LocalDateRange } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/types.mjs';
import { DatePeriod2y4m7pf19ebgd as DatePeriod } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DateTimePeriod.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { get_pageNavigatorp3to6r4j8ctv as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { SurveyDetailPage3czjqatyupm6x as SurveyDetailPage } from './SurveyDetailPage.mjs';
import {
  Companion_instance1lm8x0jadqh2g as Companion_instance,
  Platform_Web_getInstance2840w5bkfolz8 as Platform_Web_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_current2r182tjucmm5v as get_current } from '../../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { get_scrolling3fwkltztkpfe8 as get_scrolling } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  maxWidth22r11xnm7d4h4 as maxWidth,
  iconButton2nzpucy7a6ixd as iconButton,
  labeledCheckbox1ycivizfzdk0y as labeledCheckbox,
  addButton16duilic9iyqp as addButton,
} from '../components/view-utilities.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement,
  Companion_getInstanceztgx4sy4wjnt as Companion_getInstance_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  h12aidul0n4qlwh as h1,
  subtext2yjmf1ok7kb40 as subtext,
  text189ciz0cnr32o as text,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { LabeledViewseav57tyecmf as LabeledView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { NumberInput16nzuc28fuw7p as NumberInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/NumberField.commonHtml.mjs';
import { LocalDateField1854369auhx0q as LocalDateField } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LocalDateTimeField.commonHtml.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance_1 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import {
  colOfv2oygjkn5hb2 as colOf,
  colOf78ko504rukk8 as colOf_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/lists.mjs';
import { SwapView1526g6cz7z56r as SwapView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/SwapView.commonHtml.mjs';
import { Companion_getInstance29ka8gqgdrya1 as Companion_getInstance_2 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/ScreenTransitions.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { report1vfr9zf0i9d9p as report } from '../../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import {
  Button$_get_enabled_$ref_61t7nx58ibx9ifxb3n as Button$_get_enabled_$ref_61t7nx,
  Button$_set_enabled_$ref_o8kynzfmpduwei6tot as Button$_set_enabled_$ref_o8kynz,
} from '../applications/FamilyApplicationDetailPage.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  QuestionKind_SingleChoice_instance = new (QuestionKind())('SingleChoice', 0, 'Single choice');
  QuestionKind_MultipleChoice_instance = new (QuestionKind())('MultipleChoice', 1, 'Multiple choice');
  QuestionKind_Scale_instance = new (QuestionKind())('Scale', 2, 'Scale');
  QuestionKind_FreeNumber_instance = new (QuestionKind())('FreeNumber', 3, 'Number');
  QuestionKind_FreeText_instance = new (QuestionKind())('FreeText', 4, 'Free text');
}
var QuestionKind_SingleChoice_instance;
var QuestionKind_MultipleChoice_instance;
var QuestionKind_Scale_instance;
var QuestionKind_FreeNumber_instance;
var QuestionKind_FreeText_instance;
function values() {
  static_init();
  return [QuestionKind_SingleChoice_getInstance(), QuestionKind_MultipleChoice_getInstance(), QuestionKind_Scale_getInstance(), QuestionKind_FreeNumber_getInstance(), QuestionKind_FreeText_getInstance()];
}
function get_entries_0() {
  static_init();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var $ENTRIES;
var QuestionKindClass;
function QuestionKind() {
  if (QuestionKindClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, displayName) {
        super(name, ordinal);
        this.displayName_1 = displayName;
      }
    }
    initMetadataForClass($, 'QuestionKind');
    QuestionKindClass = $;
  }
  return QuestionKindClass;
}
function get_displayName(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.ordinal_1) {
    case 0:
      tmp = 'Employees (anonymous link)';
      break;
    case 1:
      tmp = 'Families';
      break;
    case 2:
      tmp = 'Employers';
      break;
    case 3:
      tmp = 'Providers';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      from_9ti2dg_k$(question) {
        var tmp0_elvis_lhs = question.item_1;
        var tmp = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
        var tmp1_safe_receiver = question.showCondition_1;
        var tmp_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.otherQuestion_1;
        var tmp2_safe_receiver = question.showCondition_1;
        var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.answerIsOneOf_1;
        var tmp_1;
        if (tmp3_elvis_lhs == null) {
          // Inline function 'kotlin.collections.setOf' call
          tmp_1 = emptySet();
        } else {
          tmp_1 = tmp3_elvis_lhs;
        }
        var draft = new (QuestionDraft())(question._id_1, question.question_1, tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, question.optional_1, question.employerMaySeeResponse_1, tmp_0, tmp_1);
        var type = question.type_1;
        var tmp_2;
        if (type instanceof SingleChoice()) {
          tmp_2 = draft.copy$default_4wq8o3_k$(VOID, VOID, VOID, QuestionKind_SingleChoice_getInstance(), joinToString(type.options_1, '\n'));
        } else {
          if (type instanceof MultipleChoice()) {
            tmp_2 = draft.copy$default_4wq8o3_k$(VOID, VOID, VOID, QuestionKind_MultipleChoice_getInstance(), joinToString(type.options_1, '\n'));
          } else {
            if (type instanceof Scale()) {
              tmp_2 = draft.copy$default_4wq8o3_k$(VOID, VOID, VOID, QuestionKind_Scale_getInstance(), VOID, type.lowerName_1, type.lowerInt_1, type.upperName_1, type.upperInt_1);
            } else {
              if (type instanceof FreeNumber()) {
                tmp_2 = draft.copy$default_4wq8o3_k$(VOID, VOID, VOID, QuestionKind_FreeNumber_getInstance(), VOID, VOID, VOID, VOID, VOID, type.prefix_1, type.postfix_1, type.integersOnly_1);
              } else {
                if (equals(type, FreeText_getInstance())) {
                  tmp_2 = draft.copy$default_4wq8o3_k$(VOID, VOID, VOID, QuestionKind_FreeText_getInstance());
                } else {
                  noWhenBranchMatchedException();
                }
              }
            }
          }
        }
        return tmp_2;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_3() {
  return Companion_instance_0;
}
var QuestionDraftClass;
function QuestionDraft() {
  if (QuestionDraftClass === VOID) {
    class $ {
      constructor(id, question, item, kind, options, lowerName, lowerInt, upperName, upperInt, prefix, postfix, integersOnly, optional, employerMaySeeResponse, showWhen, showWhenAnswers) {
        id = id === VOID ? _ID___init__impl__k1lb7e(Companion_getInstance().random_fimq0t_k$()) : id;
        question = question === VOID ? '' : question;
        item = item === VOID ? '' : item;
        kind = kind === VOID ? QuestionKind_SingleChoice_getInstance() : kind;
        options = options === VOID ? '' : options;
        lowerName = lowerName === VOID ? 'Strongly disagree' : lowerName;
        lowerInt = lowerInt === VOID ? 1 : lowerInt;
        upperName = upperName === VOID ? 'Strongly agree' : upperName;
        upperInt = upperInt === VOID ? 5 : upperInt;
        prefix = prefix === VOID ? '' : prefix;
        postfix = postfix === VOID ? '' : postfix;
        integersOnly = integersOnly === VOID ? true : integersOnly;
        optional = optional === VOID ? false : optional;
        employerMaySeeResponse = employerMaySeeResponse === VOID ? false : employerMaySeeResponse;
        showWhen = showWhen === VOID ? null : showWhen;
        var tmp;
        if (showWhenAnswers === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = showWhenAnswers;
        }
        showWhenAnswers = tmp;
        this.id_1 = id;
        this.question_1 = question;
        this.item_1 = item;
        this.kind_1 = kind;
        this.options_1 = options;
        this.lowerName_1 = lowerName;
        this.lowerInt_1 = lowerInt;
        this.upperName_1 = upperName;
        this.upperInt_1 = upperInt;
        this.prefix_1 = prefix;
        this.postfix_1 = postfix;
        this.integersOnly_1 = integersOnly;
        this.optional_1 = optional;
        this.employerMaySeeResponse_1 = employerMaySeeResponse;
        this.showWhen_1 = showWhen;
        this.showWhenAnswers_1 = showWhenAnswers;
      }
      get_optionSet_vzvf98_k$() {
        // Inline function 'kotlin.collections.map' call
        var this_0 = lines(this.options_1);
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          // Inline function 'kotlin.text.trim' call
          var tmp$ret$2 = toString(trim(isCharSequence(item) ? item : THROW_CCE()));
          destination.add_utx5q5_k$(tmp$ret$2);
        }
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        var _iterator__ex2g4s_0 = destination.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s_0.next_20eer_k$();
          // Inline function 'kotlin.text.isNotEmpty' call
          if (charSequenceLength(element) > 0) {
            destination_0.add_utx5q5_k$(element);
          }
        }
        return toSet(destination_0);
      }
      get_hasOptions_784jpv_k$() {
        return this.kind_1.equals(QuestionKind_SingleChoice_getInstance()) || this.kind_1.equals(QuestionKind_MultipleChoice_getInstance());
      }
      toQuestion_jm2s1r_k$() {
        var tmp2__id = this.id_1;
        // Inline function 'kotlin.text.trim' call
        var this_0 = this.question_1;
        var tmp3_question = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
        // Inline function 'kotlin.text.trim' call
        var this_1 = this.item_1;
        // Inline function 'kotlin.text.ifEmpty' call
        var this_2 = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
        var tmp;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(this_2) === 0) {
          tmp = null;
        } else {
          tmp = this_2;
        }
        var tmp4_item = tmp;
        var tmp5_optional = this.optional_1;
        var tmp6_employerMaySeeResponse = this.employerMaySeeResponse_1;
        var tmp0_safe_receiver = this.showWhen_1;
        var tmp_0;
        var tmp_1 = tmp0_safe_receiver;
        if ((tmp_1 == null ? null : new (ID())(tmp_1)) == null) {
          tmp_0 = null;
        } else {
          var tmp_2 = tmp0_safe_receiver;
          // Inline function 'kotlin.let' call
          var it = (tmp_2 == null ? null : new (ID())(tmp_2)).raw_1;
          tmp_0 = new (ShowCondition())(it, this.showWhenAnswers_1);
        }
        var tmp7_showCondition = tmp_0;
        var tmp_3;
        switch (this.kind_1.ordinal_1) {
          case 0:
            tmp_3 = new (SingleChoice())(this.get_optionSet_vzvf98_k$());
            break;
          case 1:
            tmp_3 = new (MultipleChoice())(this.get_optionSet_vzvf98_k$());
            break;
          case 2:
            // Inline function 'kotlin.text.trim' call

            var this_3 = this.lowerName_1;
            var tmp_4 = toString(trim(isCharSequence(this_3) ? this_3 : THROW_CCE()));
            // Inline function 'kotlin.text.trim' call

            var this_4 = this.upperName_1;
            var tmp$ret$8 = toString(trim(isCharSequence(this_4) ? this_4 : THROW_CCE()));
            tmp_3 = new (Scale())(tmp_4, this.lowerInt_1, tmp$ret$8, this.upperInt_1);
            break;
          case 3:
            // Inline function 'kotlin.text.trim' call

            var this_5 = this.prefix_1;
            var tmp_5 = toString(trim(isCharSequence(this_5) ? this_5 : THROW_CCE()));
            // Inline function 'kotlin.text.trim' call

            var this_6 = this.postfix_1;
            var tmp$ret$10 = toString(trim(isCharSequence(this_6) ? this_6 : THROW_CCE()));
            tmp_3 = new (FreeNumber())(tmp_5, tmp$ret$10, this.integersOnly_1);
            break;
          case 4:
            tmp_3 = FreeText_getInstance();
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
        var tmp8_type = tmp_3;
        return new (Question())(tmp2__id, tmp3_question, tmp4_item, tmp8_type, tmp5_optional, tmp6_employerMaySeeResponse, tmp7_showCondition);
      }
      copy_qmu6xv_k$(id, question, item, kind, options, lowerName, lowerInt, upperName, upperInt, prefix, postfix, integersOnly, optional, employerMaySeeResponse, showWhen, showWhenAnswers) {
        return new (QuestionDraft())(id, question, item, kind, options, lowerName, lowerInt, upperName, upperInt, prefix, postfix, integersOnly, optional, employerMaySeeResponse, showWhen, showWhenAnswers);
      }
      copy$default_4wq8o3_k$(id, question, item, kind, options, lowerName, lowerInt, upperName, upperInt, prefix, postfix, integersOnly, optional, employerMaySeeResponse, showWhen, showWhenAnswers, $super) {
        id = id === VOID ? this.id_1 : id;
        question = question === VOID ? this.question_1 : question;
        item = item === VOID ? this.item_1 : item;
        kind = kind === VOID ? this.kind_1 : kind;
        options = options === VOID ? this.options_1 : options;
        lowerName = lowerName === VOID ? this.lowerName_1 : lowerName;
        lowerInt = lowerInt === VOID ? this.lowerInt_1 : lowerInt;
        upperName = upperName === VOID ? this.upperName_1 : upperName;
        upperInt = upperInt === VOID ? this.upperInt_1 : upperInt;
        prefix = prefix === VOID ? this.prefix_1 : prefix;
        postfix = postfix === VOID ? this.postfix_1 : postfix;
        integersOnly = integersOnly === VOID ? this.integersOnly_1 : integersOnly;
        optional = optional === VOID ? this.optional_1 : optional;
        employerMaySeeResponse = employerMaySeeResponse === VOID ? this.employerMaySeeResponse_1 : employerMaySeeResponse;
        showWhen = showWhen === VOID ? this.showWhen_1 : showWhen;
        showWhenAnswers = showWhenAnswers === VOID ? this.showWhenAnswers_1 : showWhenAnswers;
        var tmp;
        if ($super === VOID) {
          tmp = this.copy_qmu6xv_k$(id, question, item, kind, options, lowerName, lowerInt, upperName, upperInt, prefix, postfix, integersOnly, optional, employerMaySeeResponse, showWhen, showWhenAnswers);
        } else {
          var tmp_0 = $super.copy_qmu6xv_k$;
          var tmp_1 = showWhen;
          tmp = tmp_0.call(this, new (ID())(id), question, item, kind, options, lowerName, lowerInt, upperName, upperInt, prefix, postfix, integersOnly, optional, employerMaySeeResponse, tmp_1 == null ? null : new (ID())(tmp_1), showWhenAnswers);
        }
        return tmp;
      }
      toString() {
        var tmp = ID__toString_impl_y5caka(this.id_1);
        var tmp_0 = this.kind_1.toString();
        var tmp_1 = this.showWhen_1;
        return 'QuestionDraft(id=' + tmp + ', question=' + this.question_1 + ', item=' + this.item_1 + ', kind=' + tmp_0 + ', options=' + this.options_1 + ', lowerName=' + this.lowerName_1 + ', lowerInt=' + this.lowerInt_1 + ', upperName=' + this.upperName_1 + ', upperInt=' + this.upperInt_1 + ', prefix=' + this.prefix_1 + ', postfix=' + this.postfix_1 + ', integersOnly=' + this.integersOnly_1 + ', optional=' + this.optional_1 + ', employerMaySeeResponse=' + this.employerMaySeeResponse_1 + ', showWhen=' + toString_0(tmp_1 == null ? null : new (ID())(tmp_1)) + ', showWhenAnswers=' + toString(this.showWhenAnswers_1) + ')';
      }
      hashCode() {
        var result = ID__hashCode_impl_f4lulz(this.id_1);
        result = imul(result, 31) + getStringHashCode(this.question_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.item_1) | 0;
        result = imul(result, 31) + this.kind_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.options_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.lowerName_1) | 0;
        result = imul(result, 31) + this.lowerInt_1 | 0;
        result = imul(result, 31) + getStringHashCode(this.upperName_1) | 0;
        result = imul(result, 31) + this.upperInt_1 | 0;
        result = imul(result, 31) + getStringHashCode(this.prefix_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.postfix_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.integersOnly_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.optional_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.employerMaySeeResponse_1) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.showWhen_1;
        if ((tmp_1 == null ? null : new (ID())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = ID__hashCode_impl_f4lulz(this.showWhen_1);
        }
        result = tmp + tmp_0 | 0;
        result = imul(result, 31) + hashCode(this.showWhenAnswers_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof QuestionDraft()))
          return false;
        if (!equals(this.id_1, other.id_1))
          return false;
        if (!(this.question_1 === other.question_1))
          return false;
        if (!(this.item_1 === other.item_1))
          return false;
        if (!this.kind_1.equals(other.kind_1))
          return false;
        if (!(this.options_1 === other.options_1))
          return false;
        if (!(this.lowerName_1 === other.lowerName_1))
          return false;
        if (!(this.lowerInt_1 === other.lowerInt_1))
          return false;
        if (!(this.upperName_1 === other.upperName_1))
          return false;
        if (!(this.upperInt_1 === other.upperInt_1))
          return false;
        if (!(this.prefix_1 === other.prefix_1))
          return false;
        if (!(this.postfix_1 === other.postfix_1))
          return false;
        if (!(this.integersOnly_1 === other.integersOnly_1))
          return false;
        if (!(this.optional_1 === other.optional_1))
          return false;
        if (!(this.employerMaySeeResponse_1 === other.employerMaySeeResponse_1))
          return false;
        var tmp = this.showWhen_1;
        var tmp_0 = tmp == null ? null : new (ID())(tmp);
        var tmp_1 = other.showWhen_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (ID())(tmp_1)))
          return false;
        if (!equals(this.showWhenAnswers_1, other.showWhenAnswers_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'QuestionDraft', QuestionDraft);
    QuestionDraftClass = $;
  }
  return QuestionDraftClass;
}
function SurveyNewPage$render$lambda(it) {
  return get_displayName(it);
}
function SurveyNewPage$render$lambda_0(it) {
  return it == null ? null : it;
}
function SurveyNewPage$render$lambda_1(it) {
  return it == null ? null : numberToInt(it);
}
function SurveyNewPage$render$lambda_2(it) {
  return new (ID())(it.id_1);
}
function SurveyNewPage$render$lambda$slambda$slambda($new) {
  return constructCallableReference((list, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = list;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$2 = equals(item.id_1, $new.id_1) ? $new : item;
      destination.add_utx5q5_k$(tmp$ret$2);
    }
    return destination;
  }), 1);
}
function SurveyNewPage$render$lambda$slambda(this$0) {
  return constructCallableReference(($this$withWrite, new_0, $completion) => orPromise($completion, function *($completion) {
    yield* modify(this$0.questions_1, SurveyNewPage$render$lambda$slambda$slambda(new_0), $completion);
    return Unit_instance;
  }), 2);
}
function SurveyNewPage$render$lambda$lambda(it) {
  return it.question_1;
}
function SurveyNewPage$render$lambda$lambda_0(old, it) {
  return old.copy$default_4wq8o3_k$(VOID, it);
}
function SurveyNewPage$render$lambda$lambda_1(it) {
  return it.kind_1;
}
function SurveyNewPage$render$lambda$lambda_2(old, it) {
  return old.copy$default_4wq8o3_k$(VOID, VOID, VOID, it);
}
function SurveyNewPage$render$lambda$lambda_3(it) {
  return it.displayName_1;
}
function SurveyNewPage$render$lambda$lambda_4($this$iconButton) {
  return 'Remove question';
}
function SurveyNewPage$render$lambda$lambda$slambda$slambda($draft) {
  return constructCallableReference((list, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = list;
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_0 = $draft;
      var tmp$ret$3 = yield* await_0(this_0, $completion);
      if (!equals(element.id_1, tmp$ret$3.id_1)) {
        destination.add_utx5q5_k$(element);
      }
    }
    return destination;
  }), 1);
}
function SurveyNewPage$render$lambda$lambda$slambda(this$0, $draft) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* modify(this$0.questions_1, SurveyNewPage$render$lambda$lambda$slambda$slambda($draft), $completion);
    return Unit_instance;
  }), 0);
}
function SurveyNewPage$render$lambda$lambda_5(it) {
  return it.item_1;
}
function SurveyNewPage$render$lambda$lambda_6(old, it) {
  return old.copy$default_4wq8o3_k$(VOID, VOID, it);
}
function SurveyNewPage$render$lambda$lambda_7(it) {
  return it.options_1;
}
function SurveyNewPage$render$lambda$lambda_8(old, it) {
  return old.copy$default_4wq8o3_k$(VOID, VOID, VOID, VOID, it);
}
function SurveyNewPage$render$lambda$lambda_9(it) {
  return it.lowerInt_1;
}
function SurveyNewPage$render$lambda$lambda_10(old, it) {
  var tmp1_elvis_lhs = it == null ? null : numberToInt(it);
  return old.copy$default_4wq8o3_k$(VOID, VOID, VOID, VOID, VOID, VOID, tmp1_elvis_lhs == null ? old.lowerInt_1 : tmp1_elvis_lhs);
}
function SurveyNewPage$render$lambda$lambda_11(it) {
  return it.lowerName_1;
}
function SurveyNewPage$render$lambda$lambda_12(old, it) {
  return old.copy$default_4wq8o3_k$(VOID, VOID, VOID, VOID, VOID, it);
}
function SurveyNewPage$render$lambda$lambda_13(it) {
  return it.upperInt_1;
}
function SurveyNewPage$render$lambda$lambda_14(old, it) {
  var tmp1_elvis_lhs = it == null ? null : numberToInt(it);
  return old.copy$default_4wq8o3_k$(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_elvis_lhs == null ? old.upperInt_1 : tmp1_elvis_lhs);
}
function SurveyNewPage$render$lambda$lambda_15(it) {
  return it.upperName_1;
}
function SurveyNewPage$render$lambda$lambda_16(old, it) {
  return old.copy$default_4wq8o3_k$(VOID, VOID, VOID, VOID, VOID, VOID, VOID, it);
}
function SurveyNewPage$render$lambda$lambda_17(it) {
  return it.prefix_1;
}
function SurveyNewPage$render$lambda$lambda_18(old, it) {
  return old.copy$default_4wq8o3_k$(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, it);
}
function SurveyNewPage$render$lambda$lambda_19(it) {
  return it.postfix_1;
}
function SurveyNewPage$render$lambda$lambda_20(old, it) {
  return old.copy$default_4wq8o3_k$(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, it);
}
function SurveyNewPage$render$lambda$lambda_21(it) {
  return it.integersOnly_1;
}
function SurveyNewPage$render$lambda$lambda_22(old, it) {
  return old.copy$default_4wq8o3_k$(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, it);
}
function SurveyNewPage$render$lambda$slambda_0($draft) {
  return constructCallableReference(($this$withWrite, other, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $draft;
    var tmp = yield* await_0(this_0, $completion);
    var tmp0_safe_receiver = other;
    var tmp_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.id_1;
    // Inline function 'kotlin.collections.setOf' call
    var tmp$ret$1 = emptySet();
    yield* $draft.set_revjhg_k$(tmp.copy$default_4wq8o3_k$(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, tmp$ret$1), $completion);
    return Unit_instance;
  }), 2);
}
function SurveyNewPage$render$lambda$lambda_23(it) {
  var tmp1_elvis_lhs = it == null ? null : it.question_1;
  return tmp1_elvis_lhs == null ? '(always show)' : tmp1_elvis_lhs;
}
function SurveyNewPage$render$lambda$lambda$slambda_0($draft, $option) {
  return constructCallableReference(($this$withWrite, checked, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $draft;
    var answers = (yield* await_0(this_0, $completion)).showWhenAnswers_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $draft;
    var tmp = yield* await_0(this_1, $completion);
    var tmp_0;
    if (checked) {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_2 = $option;
      var tmp$ret$2 = yield* await_0(this_2, $completion);
      tmp_0 = plus_1(answers, tmp$ret$2);
    } else {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_3 = $option;
      var tmp$ret$3 = yield* await_0(this_3, $completion);
      tmp_0 = minus(answers, tmp$ret$3);
    }
    yield* $draft.set_revjhg_k$(tmp.copy$default_4wq8o3_k$(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0), $completion);
    return Unit_instance;
  }), 2);
}
function SurveyNewPage$render$lambda$lambda_24(it) {
  return it.optional_1;
}
function SurveyNewPage$render$lambda$lambda_25(old, it) {
  return old.copy$default_4wq8o3_k$(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, it);
}
function SurveyNewPage$render$lambda$lambda_26(it) {
  return it.employerMaySeeResponse_1;
}
function SurveyNewPage$render$lambda$lambda_27(old, it) {
  return old.copy$default_4wq8o3_k$(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, it);
}
function SurveyNewPage$render$lambda$lambda$lambda$lambda(it) {
  return it;
}
function SurveyNewPage$render$lambda$lambda$lambda($next, this$0) {
  return ($this$swap) => {
    var question = $next;
    var response = new (QuestionResponse())(VOID, _ID___init__impl__k1lb7e_0(Companion_getInstance().NIL_1), question._id_1, this$0.audience_1.get_value_j01efc_k$(), Companion_getInstance().NIL_1);
    var tmp = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(response);
    questionDisplay($this$swap, question, tmp, SurveyNewPage$render$lambda$lambda$lambda$lambda);
    return Unit_instance;
  };
}
function SurveyNewPage$render$lambda_3($this$addButton) {
  return 'Add question';
}
function SurveyNewPage$render$lambda$slambda$slambda_0() {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return plus(it, new (QuestionDraft())());
  }), 1);
}
function SurveyNewPage$render$lambda$slambda_1(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* modify(this$0.questions_1, SurveyNewPage$render$lambda$slambda$slambda_0(), $completion);
    return Unit_instance;
  }), 0);
}
function SurveyNewPage$render$slambda$slambda() {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return plus(it, last(it).copy$default_4wq8o3_k$(_ID___init__impl__k1lb7e(Companion_getInstance().random_fimq0t_k$()), VOID, ''));
  }), 1);
}
function SurveyNewPage$render$slambda(this$0) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* modify(this$0.questions_1, SurveyNewPage$render$slambda$slambda(), $completion);
    return Unit_instance;
  }), 0);
}
function SurveyNewPage$render$slambda_0(this$0, $$this$button) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = this$0.name_1;
    // Inline function 'kotlin.text.trim' call
    var this_1 = yield* await_1(this_0, $completion);
    var tmp2_name = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = this$0.audience_1;
    var tmp3_audience = yield* await_1(this_2, $completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = this$0.start_1;
    var tmp0_safe_receiver = yield* await_1(this_3, $completion);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_4 = this$0.endInclusive_1;
      var tmp$ret$6 = yield* await_1(this_4, $completion);
      tmp = new (LocalDateRange())(tmp0_safe_receiver, tmp$ret$6);
    }
    var tmp4_available = tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_5 = this$0.repeatMonths_1;
    var tmp1_safe_receiver = yield* await_1(this_5, $completion);
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = DatePeriod().new_kotlinx_datetime_DatePeriod_19p8ip_k$(VOID, tmp1_safe_receiver);
    }
    var tmp5_maximumFrequency = tmp_0;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_6 = this$0.questions_1;
    // Inline function 'kotlin.collections.map' call
    var this_7 = yield* await_1(this_6, $completion);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_7, 10));
    var _iterator__ex2g4s = this_7.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$13 = item.toQuestion_jm2s1r_k$();
      destination.add_utx5q5_k$(tmp$ret$13);
    }
    var survey = new (Survey())(VOID, tmp2_name, tmp4_available, tmp5_maximumFrequency, destination, tmp3_audience);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_8 = get_currentSessionNotNull();
    yield* (yield* await_0(this_8, $completion)).get_surveys_tdixlc_k$().add_co22jy_k$(survey, $completion);
    get_pageNavigator($$this$button.get_context_h02k06_k$()).replace_7qh33u_k$(new (SurveyDetailPage())(survey._id_1));
    return Unit_instance;
  }), 1);
}
function SurveyNewPage$render$lambda_4($this$shownWhen) {
  return get_current(Companion_instance).equals(Platform_Web_getInstance());
}
var SurveyNewPageClass;
function SurveyNewPage() {
  if (SurveyNewPageClass === VOID) {
    class $ {
      constructor() {
        this.name_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$('');
        this.audience_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(Audience_AnonymousEmployee_getInstance());
        this.start_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
        this.endInclusive_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
        this.repeatMonths_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(null);
        this.questions_1 = Signal().new_com_lightningkite_reactive_core_Signal_8ohyj8_k$(listOf(new (QuestionDraft())()));
      }
      get_title_iz32un_k$() {
        return new (Constant())(_Constant___init__impl__v45mub('New Survey'));
      }
      render_w3x9d1_k$(_this__u8e3s4) {
        // Inline function 'org.thecommunitygroupinc.cares.views.components.page' call
        var this_0 = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = maxWidth(this_0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element = new (RowOrCol())(this_1.get_context_h02k06_k$());
        ensureOutermostElement(element);
        this_1.willAddChild_hz2iwc_k$(element);
        element.set_vertical_nuap32_k$(true);
        element.set_themeBase_daz04n_k$(Companion_getInstance_0().fromParentNonCascading_1);
        h1(element, 'New Survey');
        subtext(element, "Questions can't be changed once the survey is created. Leave the start date empty to keep it as a draft. In employee and employer surveys, write [company] where the employer's name should appear.");
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_0 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element.get_context_h02k06_k$());
        ensureOutermostElement(element_0);
        element.willAddChild_hz2iwc_k$(element_0);
        element_0.set_content_lzqutq_k$('Name');
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        var this_2 = themed(element_0, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_1 = new (TextInput())(this_2.get_context_h02k06_k$());
        ensureOutermostElement(element_1);
        this_2.willAddChild_hz2iwc_k$(element_1);
        element_1.bind_gesskf_k$(element_1.content_1, this.name_1);
        element_1.onStartup_vrxh3i_k$();
        this_2.addChild_2qpft2_k$(element_1);
        element_0.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_2 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_2);
        element.willAddChild_hz2iwc_k$(element_2);
        element_2.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var tmp0 = weight(element_2, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        var label = 'Audience';
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_3 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(tmp0.get_context_h02k06_k$());
        ensureOutermostElement(element_3);
        tmp0.willAddChild_hz2iwc_k$(element_3);
        element_3.set_content_lzqutq_k$(label);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.select' call
        var this_3 = themed(element_3, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_4 = new (Select())(this_3.get_context_h02k06_k$());
        ensureOutermostElement(element_4);
        this_3.willAddChild_hz2iwc_k$(element_4);
        var tmp = _Constant___init__impl__v45mub(get_entries());
        element_4.bind_64a41i_k$(this.audience_1, new (Constant())(tmp), SurveyNewPage$render$lambda);
        element_4.onStartup_vrxh3i_k$();
        this_3.addChild_2qpft2_k$(element_4);
        element_3.onStartup_vrxh3i_k$();
        tmp0.addChild_2qpft2_k$(element_3);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var tmp0_0 = weight(element_2, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        var label_0 = 'Repeat at most every (months; empty for once)';
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_5 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(tmp0_0.get_context_h02k06_k$());
        ensureOutermostElement(element_5);
        tmp0_0.willAddChild_hz2iwc_k$(element_5);
        element_5.set_content_lzqutq_k$(label_0);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
        var this_4 = themed(element_5, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_6 = new (NumberInput())(this_4.get_context_h02k06_k$());
        ensureOutermostElement(element_6);
        this_4.willAddChild_hz2iwc_k$(element_6);
        var tmp_0 = SurveyNewPage$render$lambda_0;
        element_6.bind_gesskf_k$(element_6.content_1, this.repeatMonths_1.lens_drj4fu_k$(tmp_0, SurveyNewPage$render$lambda_1));
        element_6.onStartup_vrxh3i_k$();
        this_4.addChild_2qpft2_k$(element_6);
        element_5.onStartup_vrxh3i_k$();
        tmp0_0.addChild_2qpft2_k$(element_5);
        element_2.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_2);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_7 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_7);
        element.willAddChild_hz2iwc_k$(element_7);
        element_7.set_vertical_nuap32_k$(false);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        var this_5 = weight(element_7, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_8 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_5.get_context_h02k06_k$());
        ensureOutermostElement(element_8);
        this_5.willAddChild_hz2iwc_k$(element_8);
        element_8.set_content_lzqutq_k$('Opens');
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
        var this_6 = themed(element_8, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_9 = new (LocalDateField())(this_6.get_context_h02k06_k$());
        ensureOutermostElement(element_9);
        this_6.willAddChild_hz2iwc_k$(element_9);
        element_9.bind_gesskf_k$(element_9.content_1, this.start_1);
        element_9.onStartup_vrxh3i_k$();
        this_6.addChild_2qpft2_k$(element_9);
        element_8.onStartup_vrxh3i_k$();
        this_5.addChild_2qpft2_k$(element_8);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        var tmp0_1 = weight(element_7, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        var label_1 = 'Closes (optional)';
        // Inline function 'com.lightningkite.kiteui.views.l2.label' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_10 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(tmp0_1.get_context_h02k06_k$());
        ensureOutermostElement(element_10);
        tmp0_1.willAddChild_hz2iwc_k$(element_10);
        element_10.set_content_lzqutq_k$(label_1);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
        var this_7 = themed(element_10, FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_11 = new (LocalDateField())(this_7.get_context_h02k06_k$());
        ensureOutermostElement(element_11);
        this_7.willAddChild_hz2iwc_k$(element_11);
        element_11.bind_gesskf_k$(element_11.content_1, this.endInclusive_1);
        element_11.onStartup_vrxh3i_k$();
        this_7.addChild_2qpft2_k$(element_11);
        element_10.onStartup_vrxh3i_k$();
        tmp0_1.addChild_2qpft2_k$(element_10);
        element_7.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_7);
        var tmp_1 = SurveyNewPage$render$lambda_2;
        colOf_0(element, this.questions_1, tmp_1, VOID, VOID, ($this$colOf, item) => {
          var draft = withWrite(item, SurveyNewPage$render$lambda$slambda(this));
          // Inline function 'com.lightningkite.kiteui.views.card' call
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          var this_0 = themed($this$colOf, CardSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
          ensureOutermostElement(element);
          this_0.willAddChild_hz2iwc_k$(element);
          element.set_vertical_nuap32_k$(true);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_0);
          element.willAddChild_hz2iwc_k$(element_0);
          element_0.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          var this_1 = get_centered(element_0);
          var tmp0 = weight(this_1, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          var label = 'Question';
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_1 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(tmp0.get_context_h02k06_k$());
          ensureOutermostElement(element_1);
          tmp0.willAddChild_hz2iwc_k$(element_1);
          element_1.set_content_lzqutq_k$(label);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          var this_2 = themed(element_1, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_2 = new (TextInput())(this_2.get_context_h02k06_k$());
          ensureOutermostElement(element_2);
          this_2.willAddChild_hz2iwc_k$(element_2);
          var tmp = SurveyNewPage$render$lambda$lambda;
          element_2.bind_gesskf_k$(element_2.content_1, draft.lens_u4wb4z_k$(tmp, SurveyNewPage$render$lambda$lambda_0));
          element_2.onStartup_vrxh3i_k$();
          this_2.addChild_2qpft2_k$(element_2);
          element_1.onStartup_vrxh3i_k$();
          tmp0.addChild_2qpft2_k$(element_1);
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          var this_3 = get_centered(element_0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_3 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_3.get_context_h02k06_k$());
          ensureOutermostElement(element_3);
          this_3.willAddChild_hz2iwc_k$(element_3);
          element_3.set_content_lzqutq_k$('Type');
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          var this_4 = themed(element_3, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_4 = new (Select())(this_4.get_context_h02k06_k$());
          ensureOutermostElement(element_4);
          this_4.willAddChild_hz2iwc_k$(element_4);
          var tmp_0 = SurveyNewPage$render$lambda$lambda_1;
          var tmp_1 = draft.lens_u4wb4z_k$(tmp_0, SurveyNewPage$render$lambda$lambda_2);
          var tmp_2 = _Constant___init__impl__v45mub(get_entries_0());
          element_4.bind_64a41i_k$(tmp_1, new (Constant())(tmp_2), SurveyNewPage$render$lambda$lambda_3);
          element_4.onStartup_vrxh3i_k$();
          this_4.addChild_2qpft2_k$(element_4);
          element_3.onStartup_vrxh3i_k$();
          this_3.addChild_2qpft2_k$(element_3);
          var tmp_3 = get_centered(element_0);
          var tmp_4 = Companion_getInstance_1().delete_1;
          var tmp_5 = SurveyNewPage$render$lambda$lambda_4;
          iconButton(tmp_3, tmp_4, tmp_5, ($this$iconButton) => {
            onClick($this$iconButton, VOID, VOID, VOID, SurveyNewPage$render$lambda$lambda$slambda(this, draft));
            return Unit_instance;
          });
          element_0.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_0);
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          var label_0 = 'Row label, for a matrix (consecutive questions with the same text show as one grid)';
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_5 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element.get_context_h02k06_k$());
          ensureOutermostElement(element_5);
          element.willAddChild_hz2iwc_k$(element_5);
          element_5.set_content_lzqutq_k$(label_0);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          var this_5 = themed(element_5, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_6 = new (TextInput())(this_5.get_context_h02k06_k$());
          ensureOutermostElement(element_6);
          this_5.willAddChild_hz2iwc_k$(element_6);
          var tmp_6 = SurveyNewPage$render$lambda$lambda_5;
          element_6.bind_gesskf_k$(element_6.content_1, draft.lens_u4wb4z_k$(tmp_6, SurveyNewPage$render$lambda$lambda_6));
          element_6.onStartup_vrxh3i_k$();
          this_5.addChild_2qpft2_k$(element_6);
          element_5.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_5);
          var tmp0_0 = shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(draft).get_hasOptions_784jpv_k$());
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          var label_1 = 'Options, one per line';
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_7 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(tmp0_0.get_context_h02k06_k$());
          ensureOutermostElement(element_7);
          tmp0_0.willAddChild_hz2iwc_k$(element_7);
          element_7.set_content_lzqutq_k$(label_1);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
          var this_6 = themed(element_7, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_8 = new (TextArea())(this_6.get_context_h02k06_k$());
          ensureOutermostElement(element_8);
          this_6.willAddChild_hz2iwc_k$(element_8);
          var tmp_7 = SurveyNewPage$render$lambda$lambda_7;
          element_8.bind_gesskf_k$(element_8.content_1, draft.lens_u4wb4z_k$(tmp_7, SurveyNewPage$render$lambda$lambda_8));
          element_8.onStartup_vrxh3i_k$();
          this_6.addChild_2qpft2_k$(element_8);
          element_7.onStartup_vrxh3i_k$();
          tmp0_0.addChild_2qpft2_k$(element_7);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          var this_7 = shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(draft).kind_1.equals(QuestionKind_Scale_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_9 = new (RowOrCol())(this_7.get_context_h02k06_k$());
          ensureOutermostElement(element_9);
          this_7.willAddChild_hz2iwc_k$(element_9);
          element_9.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          var this_8 = weight(element_9, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_10 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(this_8.get_context_h02k06_k$());
          ensureOutermostElement(element_10);
          this_8.willAddChild_hz2iwc_k$(element_10);
          element_10.set_content_lzqutq_k$('Low end');
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
          var this_9 = themed(element_10, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_11 = new (NumberInput())(this_9.get_context_h02k06_k$());
          ensureOutermostElement(element_11);
          this_9.willAddChild_hz2iwc_k$(element_11);
          var tmp_8 = SurveyNewPage$render$lambda$lambda_9;
          element_11.bind_gesskf_k$(element_11.content_1, draft.lens_u4wb4z_k$(tmp_8, SurveyNewPage$render$lambda$lambda_10));
          element_11.onStartup_vrxh3i_k$();
          this_9.addChild_2qpft2_k$(element_11);
          element_10.onStartup_vrxh3i_k$();
          this_8.addChild_2qpft2_k$(element_10);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          var tmp0_1 = weight(element_9, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          var label_2 = 'Low label';
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_12 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(tmp0_1.get_context_h02k06_k$());
          ensureOutermostElement(element_12);
          tmp0_1.willAddChild_hz2iwc_k$(element_12);
          element_12.set_content_lzqutq_k$(label_2);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          var this_10 = themed(element_12, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_13 = new (TextInput())(this_10.get_context_h02k06_k$());
          ensureOutermostElement(element_13);
          this_10.willAddChild_hz2iwc_k$(element_13);
          var tmp_9 = SurveyNewPage$render$lambda$lambda_11;
          element_13.bind_gesskf_k$(element_13.content_1, draft.lens_u4wb4z_k$(tmp_9, SurveyNewPage$render$lambda$lambda_12));
          element_13.onStartup_vrxh3i_k$();
          this_10.addChild_2qpft2_k$(element_13);
          element_12.onStartup_vrxh3i_k$();
          tmp0_1.addChild_2qpft2_k$(element_12);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          var tmp0_2 = weight(element_9, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          var label_3 = 'High end';
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_14 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(tmp0_2.get_context_h02k06_k$());
          ensureOutermostElement(element_14);
          tmp0_2.willAddChild_hz2iwc_k$(element_14);
          element_14.set_content_lzqutq_k$(label_3);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.numberInput' call
          var this_11 = themed(element_14, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_15 = new (NumberInput())(this_11.get_context_h02k06_k$());
          ensureOutermostElement(element_15);
          this_11.willAddChild_hz2iwc_k$(element_15);
          var tmp_10 = SurveyNewPage$render$lambda$lambda_13;
          element_15.bind_gesskf_k$(element_15.content_1, draft.lens_u4wb4z_k$(tmp_10, SurveyNewPage$render$lambda$lambda_14));
          element_15.onStartup_vrxh3i_k$();
          this_11.addChild_2qpft2_k$(element_15);
          element_14.onStartup_vrxh3i_k$();
          tmp0_2.addChild_2qpft2_k$(element_14);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          var tmp0_3 = weight(element_9, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          var label_4 = 'High label';
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_16 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(tmp0_3.get_context_h02k06_k$());
          ensureOutermostElement(element_16);
          tmp0_3.willAddChild_hz2iwc_k$(element_16);
          element_16.set_content_lzqutq_k$(label_4);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          var this_12 = themed(element_16, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_17 = new (TextInput())(this_12.get_context_h02k06_k$());
          ensureOutermostElement(element_17);
          this_12.willAddChild_hz2iwc_k$(element_17);
          var tmp_11 = SurveyNewPage$render$lambda$lambda_15;
          element_17.bind_gesskf_k$(element_17.content_1, draft.lens_u4wb4z_k$(tmp_11, SurveyNewPage$render$lambda$lambda_16));
          element_17.onStartup_vrxh3i_k$();
          this_12.addChild_2qpft2_k$(element_17);
          element_16.onStartup_vrxh3i_k$();
          tmp0_3.addChild_2qpft2_k$(element_16);
          element_9.onStartup_vrxh3i_k$();
          this_7.addChild_2qpft2_k$(element_9);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          var this_13 = shownWhen(element, VOID, VOID, ($this$shownWhen) => $this$shownWhen.invoke_r7m7el_k$(draft).kind_1.equals(QuestionKind_FreeNumber_getInstance()));
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_18 = new (RowOrCol())(this_13.get_context_h02k06_k$());
          ensureOutermostElement(element_18);
          this_13.willAddChild_hz2iwc_k$(element_18);
          element_18.set_vertical_nuap32_k$(false);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          var tmp0_4 = weight(element_18, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          var label_5 = 'Before the number';
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_19 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(tmp0_4.get_context_h02k06_k$());
          ensureOutermostElement(element_19);
          tmp0_4.willAddChild_hz2iwc_k$(element_19);
          element_19.set_content_lzqutq_k$(label_5);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          var this_14 = themed(element_19, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_20 = new (TextInput())(this_14.get_context_h02k06_k$());
          ensureOutermostElement(element_20);
          this_14.willAddChild_hz2iwc_k$(element_20);
          var tmp_12 = SurveyNewPage$render$lambda$lambda_17;
          element_20.bind_gesskf_k$(element_20.content_1, draft.lens_u4wb4z_k$(tmp_12, SurveyNewPage$render$lambda$lambda_18));
          element_20.onStartup_vrxh3i_k$();
          this_14.addChild_2qpft2_k$(element_20);
          element_19.onStartup_vrxh3i_k$();
          tmp0_4.addChild_2qpft2_k$(element_19);
          // Inline function 'com.lightningkite.kiteui.views.expanding' call
          var tmp0_5 = weight(element_18, 1.0);
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          var label_6 = 'After the number';
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_21 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(tmp0_5.get_context_h02k06_k$());
          ensureOutermostElement(element_21);
          tmp0_5.willAddChild_hz2iwc_k$(element_21);
          element_21.set_content_lzqutq_k$(label_6);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          var this_15 = themed(element_21, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_22 = new (TextInput())(this_15.get_context_h02k06_k$());
          ensureOutermostElement(element_22);
          this_15.willAddChild_hz2iwc_k$(element_22);
          var tmp_13 = SurveyNewPage$render$lambda$lambda_19;
          element_22.bind_gesskf_k$(element_22.content_1, draft.lens_u4wb4z_k$(tmp_13, SurveyNewPage$render$lambda$lambda_20));
          element_22.onStartup_vrxh3i_k$();
          this_15.addChild_2qpft2_k$(element_22);
          element_21.onStartup_vrxh3i_k$();
          tmp0_5.addChild_2qpft2_k$(element_21);
          var tmp_14 = get_centered(element_18);
          var tmp_15 = SurveyNewPage$render$lambda$lambda_21;
          labeledCheckbox(tmp_14, 'Whole numbers only', draft.lens_u4wb4z_k$(tmp_15, SurveyNewPage$render$lambda$lambda_22));
          element_18.onStartup_vrxh3i_k$();
          this_13.addChild_2qpft2_k$(element_18);
          var earlierChoices = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
            // Inline function 'kotlin.collections.takeWhile' call
            var this_0 = $this$remember.invoke_r7m7el_k$(this.questions_1);
            var list = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
            var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
            $l$loop: while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var item = _iterator__ex2g4s.next_20eer_k$();
              if (!!equals(item.id_1, $this$remember.invoke_r7m7el_k$(draft).id_1))
                break $l$loop;
              list.add_utx5q5_k$(item);
            }
            // Inline function 'kotlin.collections.filter' call
            // Inline function 'kotlin.collections.filterTo' call
            var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
            var _iterator__ex2g4s_0 = list.iterator_jk1svi_k$();
            while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
              var element = _iterator__ex2g4s_0.next_20eer_k$();
              if (element.get_hasOptions_784jpv_k$()) {
                destination.add_utx5q5_k$(element);
              }
            }
            return destination;
          });
          var tmp_16 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
            // Inline function 'kotlin.collections.find' call
            var tmp0 = $this$remember.invoke_r7m7el_k$(this.questions_1);
            var tmp$ret$183;
            $l$block: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
              while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
                var element = _iterator__ex2g4s.next_20eer_k$();
                var tmp = $this$remember.invoke_r7m7el_k$(draft).showWhen_1;
                if (equals(new (ID())(element.id_1), tmp == null ? null : new (ID())(tmp))) {
                  tmp$ret$183 = element;
                  break $l$block;
                }
              }
              tmp$ret$183 = null;
            }
            return tmp$ret$183;
          });
          var dependsOn = withWrite(tmp_16, SurveyNewPage$render$lambda$slambda_0(draft));
          var tmp0_6 = shownWhen(element, VOID, VOID, ($this$shownWhen) => {
            // Inline function 'kotlin.collections.isNotEmpty' call
            return !$this$shownWhen.invoke_r7m7el_k$(earlierChoices).isEmpty_y1axqb_k$();
          });
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          var label_7 = 'Show only when this earlier question is answered with\u2026';
          // Inline function 'com.lightningkite.kiteui.views.l2.label' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_23 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(tmp0_6.get_context_h02k06_k$());
          ensureOutermostElement(element_23);
          tmp0_6.willAddChild_hz2iwc_k$(element_23);
          element_23.set_content_lzqutq_k$(label_7);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          // Inline function 'com.lightningkite.kiteui.views.direct.select' call
          var this_16 = themed(element_23, FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_24 = new (Select())(this_16.get_context_h02k06_k$());
          ensureOutermostElement(element_24);
          this_16.willAddChild_hz2iwc_k$(element_24);
          var tmp_17 = remember(VOID, VOID, VOID, VOID, ($this$remember) => plus_0(listOf(null), $this$remember.invoke_r7m7el_k$(earlierChoices)));
          element_24.bind_64a41i_k$(dependsOn, tmp_17, SurveyNewPage$render$lambda$lambda_23);
          element_24.onStartup_vrxh3i_k$();
          this_16.addChild_2qpft2_k$(element_24);
          element_23.onStartup_vrxh3i_k$();
          tmp0_6.addChild_2qpft2_k$(element_23);
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          var this_17 = shownWhen(element, VOID, VOID, ($this$shownWhen) => !($this$shownWhen.invoke_r7m7el_k$(dependsOn) == null));
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_25 = new (RowOrCol())(this_17.get_context_h02k06_k$());
          ensureOutermostElement(element_25);
          this_17.willAddChild_hz2iwc_k$(element_25);
          element_25.set_vertical_nuap32_k$(true);
          var tmp_18 = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
            var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$(dependsOn);
            var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_optionSet_vzvf98_k$();
            var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toList(tmp1_safe_receiver);
            var tmp;
            if (tmp2_elvis_lhs == null) {
              // Inline function 'kotlin.collections.listOf' call
              tmp = emptyList();
            } else {
              tmp = tmp2_elvis_lhs;
            }
            return tmp;
          });
          colOf(element_25, tmp_18, VOID, VOID, VOID, ($this$colOf, option) => {
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element = new (RowOrCol())($this$colOf.get_context_h02k06_k$());
            ensureOutermostElement(element);
            $this$colOf.willAddChild_hz2iwc_k$(element);
            element.set_vertical_nuap32_k$(false);
            // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
            var this_0 = get_centered(element);
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_0 = new (Checkbox())(this_0.get_context_h02k06_k$());
            ensureOutermostElement(element_0);
            this_0.willAddChild_hz2iwc_k$(element_0);
            var tmp = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$(draft).showWhenAnswers_1.contains_aljjnj_k$($this$remember.invoke_r7m7el_k$(option)));
            element_0.bind_gesskf_k$(element_0.checked_1, withWrite(tmp, SurveyNewPage$render$lambda$lambda$slambda_0(draft, option)));
            element_0.onStartup_vrxh3i_k$();
            this_0.addChild_2qpft2_k$(element_0);
            // Inline function 'com.lightningkite.kiteui.views.direct.text' call
            var this_1 = get_centered(element);
            // Inline function 'com.lightningkite.kiteui.views.write' call
            var element_1 = new (TextView())(this_1.get_context_h02k06_k$());
            ensureOutermostElement(element_1);
            this_1.willAddChild_hz2iwc_k$(element_1);
            var tmp_0 = KMutableProperty0();
            var tmp_1 = TextView$_get_content_$ref_4pzcwl(element_1);
            var tmp_2 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb(element_1));
            element_1.invoke_bnq13k_k$(tmp_2, ($this$invoke) => $this$invoke.invoke_r7m7el_k$(option));
            element_1.onStartup_vrxh3i_k$();
            this_1.addChild_2qpft2_k$(element_1);
            element.onStartup_vrxh3i_k$();
            $this$colOf.addChild_2qpft2_k$(element);
            return Unit_instance;
          });
          element_25.onStartup_vrxh3i_k$();
          this_17.addChild_2qpft2_k$(element_25);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_26 = new (RowOrCol())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_26);
          element.willAddChild_hz2iwc_k$(element_26);
          element_26.set_vertical_nuap32_k$(false);
          var tmp_19 = SurveyNewPage$render$lambda$lambda_24;
          labeledCheckbox(element_26, 'Optional', draft.lens_u4wb4z_k$(tmp_19, SurveyNewPage$render$lambda$lambda_25));
          var tmp_20 = SurveyNewPage$render$lambda$lambda_26;
          labeledCheckbox(element_26, 'Employers may see family answers to this question', draft.lens_u4wb4z_k$(tmp_20, SurveyNewPage$render$lambda$lambda_27));
          element_26.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_26);
          subtext(element, 'Preview');
          // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
          // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
          // Inline function 'com.lightningkite.kiteui.views.write' call
          var element_27 = new (SwapView())(element.get_context_h02k06_k$());
          ensureOutermostElement(element_27);
          element.willAddChild_hz2iwc_k$(element_27);
          // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
          var this_18 = element_27;
          var queue = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var alreadySwapping = {_v: false};
          reactive(this_18, 8, ($this$reactive) => {
            var c = $this$reactive.invoke_r7m7el_k$(draft).toQuestion_jm2s1r_k$();
            queue.add_utx5q5_k$(c);
            var tmp;
            if (alreadySwapping._v) {
              return Unit_instance;
            }
            alreadySwapping._v = true;
            $l$loop_0: while (true) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!!queue.isEmpty_y1axqb_k$()) {
                break $l$loop_0;
              }
              var next = queue.removeAt_6niowx_k$(0);
              try {
                var tmp_0 = Companion_getInstance_2().Fade_1;
                this_18.swap_26x94b_k$(tmp_0, SurveyNewPage$render$lambda$lambda$lambda(next, this));
              } catch ($p) {
                if ($p instanceof Exception()) {
                  var e = $p;
                  report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to render ' + toString_0(next), e), 'SwapView.swapping');
                } else {
                  throw $p;
                }
              }
            }
            alreadySwapping._v = false;
            return Unit_instance;
          });
          element_27.onStartup_vrxh3i_k$();
          element.addChild_2qpft2_k$(element_27);
          element.onStartup_vrxh3i_k$();
          this_0.addChild_2qpft2_k$(element);
          return Unit_instance;
        });
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_12 = new (RowOrCol())(element.get_context_h02k06_k$());
        ensureOutermostElement(element_12);
        element.willAddChild_hz2iwc_k$(element_12);
        element_12.set_vertical_nuap32_k$(false);
        var tmp_2 = SurveyNewPage$render$lambda_3;
        addButton(element_12, tmp_2, ($this$addButton) => {
          onClick($this$addButton, VOID, VOID, VOID, SurveyNewPage$render$lambda$slambda_1(this));
          return Unit_instance;
        });
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_8 = themed(element_12, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_13 = new (Button())(this_8.get_context_h02k06_k$());
        ensureOutermostElement(element_13);
        this_8.willAddChild_hz2iwc_k$(element_13);
        text(element_13, 'Add matrix row');
        var tmp_3 = KMutableProperty0();
        var tmp_4 = Button$_get_enabled_$ref_61t7nx(element_13);
        var tmp_5 = getPropertyCallableRef('enabled', 0, tmp_3, tmp_4, Button$_set_enabled_$ref_o8kynz(element_13));
        element_13.invoke_bnq13k_k$(tmp_5, ($this$invoke) => {
          // Inline function 'kotlin.collections.isNotEmpty' call
          return !$this$invoke.invoke_r7m7el_k$(this.questions_1).isEmpty_y1axqb_k$();
        });
        onClick(element_13, VOID, VOID, VOID, SurveyNewPage$render$slambda(this));
        element_13.onStartup_vrxh3i_k$();
        this_8.addChild_2qpft2_k$(element_13);
        // Inline function 'com.lightningkite.kiteui.views.expanding' call
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_9 = weight(element_12, 1.0);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_14 = new (Space())(this_9.get_context_h02k06_k$());
        ensureOutermostElement(element_14);
        this_9.willAddChild_hz2iwc_k$(element_14);
        element_14.onStartup_vrxh3i_k$();
        this_9.addChild_2qpft2_k$(element_14);
        // Inline function 'com.lightningkite.kiteui.views.important' call
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var this_10 = themed(element_12, ImportantSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        var this_11 = themed(this_10, ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_15 = new (Button())(this_11.get_context_h02k06_k$());
        ensureOutermostElement(element_15);
        this_11.willAddChild_hz2iwc_k$(element_15);
        text(element_15, 'Create survey');
        element_15.set_action_2ds022_k$(Action('Create survey', VOID, VOID, VOID, VOID, VOID, SurveyNewPage$render$slambda_0(this, element_15)));
        element_15.onStartup_vrxh3i_k$();
        this_11.addChild_2qpft2_k$(element_15);
        element_12.onStartup_vrxh3i_k$();
        element.addChild_2qpft2_k$(element_12);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        var this_12 = shownWhen(element, VOID, VOID, SurveyNewPage$render$lambda_4);
        // Inline function 'com.lightningkite.kiteui.views.write' call
        var element_16 = new (Space())(this_12.get_context_h02k06_k$(), 1.0);
        ensureOutermostElement(element_16);
        this_12.willAddChild_hz2iwc_k$(element_16);
        element_16.onStartup_vrxh3i_k$();
        this_12.addChild_2qpft2_k$(element_16);
        element.onStartup_vrxh3i_k$();
        this_1.addChild_2qpft2_k$(element);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'SurveyNewPage', SurveyNewPage, VOID, [Page()]);
    SurveyNewPageClass = $;
  }
  return SurveyNewPageClass;
}
function QuestionKind_SingleChoice_getInstance() {
  static_init();
  return QuestionKind_SingleChoice_instance;
}
function QuestionKind_MultipleChoice_getInstance() {
  static_init();
  return QuestionKind_MultipleChoice_instance;
}
function QuestionKind_Scale_getInstance() {
  static_init();
  return QuestionKind_Scale_instance;
}
function QuestionKind_FreeNumber_getInstance() {
  static_init();
  return QuestionKind_FreeNumber_instance;
}
function QuestionKind_FreeText_getInstance() {
  static_init();
  return QuestionKind_FreeText_instance;
}
//region block: init
Companion_instance_0 = new (Companion())();
//endregion
//region block: exports
export {
  Companion_instance_0 as Companion_instance2m38mzj1la79m,
  SurveyNewPage as SurveyNewPage2cofqn1wxyvtq,
  get_displayName as get_displayNamexov4bi48nyz9,
};
//endregion

//# sourceMappingURL=SurveyNewPage.mjs.map
